<template>
  <v-card>
    <v-card-actions>
      <v-card-title class="headline"> ID : {{ card_data.id ? card_data.id : 'новый объект' }}
      </v-card-title>
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" text @click="cancel()">{{ $t('cancel') }}</v-btn>
      <v-btn color="green darken-1" text
        @click="save_rec()">Сохранить
      </v-btn>
    </v-card-actions>

    <v-card-text v-for="string in fields[current_ref_type['id']]" :key="string['field']">
      <v-text-field
        v-if="string['type'] == 'text'"
        :label="string['descr']"
        v-model="card_data[string['field']]"
        :rules="string['rules']== 'req' ? rules_req : rules_base"
        hide-details="auto"
      ></v-text-field>

      <v-switch
        v-if="string['type'] == 'checkbox'"
        :label="string['descr']"
        v-model="card_data[string['field']]"
        color="success"
        hide-details
      ></v-switch>

      <v-select
        v-if="string['type'] == 'select'"
        :items="select_items[string['selects_name']]"
        item-text="name"
        item-value="id"
        outlined
        v-model="card_data[string['field']]"
        :rules="string['rules']== 'req' ? rules_req : rules_base"
      ></v-select>


    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" text @click="cancel()">{{ $t('cancel') }}</v-btn>
      <v-btn color="green darken-1" text
        @click="save_rec()">Сохранить
      </v-btn>
    </v-card-actions>
  </v-card>
</template>


<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'

  export default {
    props: {
      card_data: Object,
      current_ref_type: Object,
    },
    data: () => ({
      fields:[
        [
          {descr: 'is_active', field: 'is_active', type: 'checkbox', rules: 'base'},
          {descr: 'Название', field: 'name', type: 'text', rules: 'req'},
          {descr: 'Сокращенное название', field: 'abbreviation', type: 'text', rules: 'req'},
          {descr: 'Название EN', field: 'name_en', type: 'text', rules: 'base'},
          {descr: 'Сокращенное название EN', field: 'abbreviation_en', type: 'text', rules: 'base'},
          {descr: 'Тип', field: 'type_org', type: 'select', rules: 'base', selects_name: 'org_type'},
          {descr: 'E-mail', field: 'email', type: 'text', rules: 'base'},
          {descr: 'Веб-сайт', field: 'web', type: 'text', rules: 'base'},
          {descr: 'Страна', field: 'country', type: 'text', rules: 'base'},
          {descr: 'Регион', field: 'region', type: 'text', rules: 'base'},
          {descr: 'Город', field: 'city', type: 'text', rules: 'base'},
          {descr: 'Адрес', field: 'address', type: 'text', rules: 'base'},
          // {descr: 'Адрес EN', field: 'address_en', type: 'text', rules: 'base'},
          {descr: 'Директор', field: 'director', type: 'text', rules: 'base'},
          // {descr: 'Директор EN', field: 'director_en', type: 'text', rules: 'base'},
          {descr: 'ИНН', field: 'TIN', type: 'text', rules: 'base'},
          {descr: 'Банковские реквизиты', field: 'bank_details', type: 'text', rules: 'base'},
        ],
        [
          {descr: 'Должность', field: 'title', type: 'text', rules: 'req'},
        ]
      ],
      select_items:{
        org_type: [
          {name: 'академический институт', id: 'academic'},
          {name: 'отраслевой институт', id: 'otrslevoi'},
          {name: 'университет', id: 'universitet'},
          {name: 'коммерческая организация', id: 'commercial'},
          {name: 'учреждение культуры (музеи)', id: 'culture'},
          {name: 'медицинское учреждение', id: 'medical'},
        ]
      },

      rules_req: [
        value => !!value || 'Обязательное поле',
        value => (value && value.length >= 3) || 'Min 3 characters',
      ],
      rules_base: [
      ],
    }),

    methods:{
      ...mapActions([
        'UPDATE_REFERENCE',
      ]),
      ...mapMutations([
        'UPDATE_OVERLAY',
      ]),

      save_rec(){
        this.UPDATE_OVERLAY(true)
        this.UPDATE_REFERENCE({
          bd_name: this.current_ref_type['bd_name'],
          data: this.card_data
        })
          .then((res) => {
            this.UPDATE_OVERLAY(false)
            this.$emit('reloadLists');
            this.$emit('closeDialog');
          })
          .catch(() => {
            this.UPDATE_OVERLAY(false)
          });
      },

      cancel(){
        this.$emit('closeDialog');
      },

    },
  }
</script>

